import './ComponentStep.scss';

export { default } from './ComponentStep';
